import React, { useMemo, useCallback, useEffect, useState } from 'react'
import GridPanel from '../../components/GridPanel'
import { useTextResources } from '../../language'
import PropTypes from "prop-types";
import moment from 'moment'
import { onError, onWarning } from '../../components/shared/messages';
import { GetUsers, PostBooking, ValidateIsEnableCancelPostBooking, CancelPostBooking } from '../../api/services/finance'
import _ from 'lodash'
import { Currencies } from '../../components/shared/currencies';
import Panel from '../../components/shared/Panel';
import { Menu, Button, Icon, Popup } from 'semantic-ui-react';
import AddFolioPopup from './addFolioPopup';
import TransferToFolioPopup from './transferToFolio';
import ProformaPopup from './proforma';
import { GetHotels } from '../../api/services/organization';
import { dateFormat, dateTimeFormat } from '../../components/shared/constants';


const TransactionsGrid = ({ HotelID, transactions, reservation, folio, currencyId }) => {
    const text = useTextResources()
    const [users, setUsers] = useState([])
    const [selected, setSelected] = useState([])
    const [showAddFolio, setShowAddFolio] = useState(false)
    const [showTransferToFolio, setShowTransferToFolio] = useState(false)
    const [showProforma, setShowProforma] = useState(false)
    const [hotel, setHotel] = useState()

    useEffect(()=>{
        console.log(selected)
    }, [selected])

    const date = useCallback(date => {
        return moment(date).format(dateFormat)
    }, [])
    const dateTime = useCallback(date => {
        return moment(date).format(dateTimeFormat)
    }, [])
    const price = useCallback((row, value) => {
        let val = value.toFixed(2)
        if (row) {
            const c = Currencies[row.CurrencyId]
            return `${val} ${c ? c.symbol : ''}`
        } else {
            return val
        }
    }, [])

    useEffect(() => {
        (async () => {
            try {
                const users = await GetUsers({
                    IDs: _.uniq(transactions.map(transaction => transaction.UserID))
                })
                setUsers(users)
                const hotel = await GetHotels({
                    ID: HotelID,
                    IsActive: true,
                    IncludeParameters: true
                })
                setHotel(hotel[0])
            } catch (error) {
                onError(error)
            }
        })()
    }, [transactions])

    /* eslint-disable react/prop-types */
    /* eslint-disable react/display-name */
    const options = useMemo(() => {
        return {
            columns: [
                { name: 'InvoiceID', title: text("Invoice"), getCellValue: row => row.InvoiceID || "None" },
                { name: 'TransactionCode.Name', title: text("DisplayName"), getCellValue: row => row.TransactionCode.Name },
                { name: 'PrintDate', title: text("ValueDate"), formatter: ({ value }) => date(value) },
                { name: 'TransactionDate', title: text("ActualDate"), formatter: ({ value }) => dateTime(value) },
                { name: 'Quantity', title: text("Quantity") },
                {
                    name: 'AmountByTargetCurrencyID', title: text("Amount"), formatter: ({ row, value }) => {
                        return <span className={value < 0 ? "negative" : "positive"}>{price(row, value)}</span>
                    }
                },
                {
                    name: 'UserID', title: text("User"), formatter: ({ value }) => {
                        const user = users.find(user => user.Id === value)
                        return user ? user.UserName : ''
                    }
                },
                {
                    name: "SourceDestination", title: text("SourceDestinationFolio"), getCellValue: row => {
                        if (row.SourceFolioId) {
                            const val = text("SourceFolio")
                            return `${val}: ${row.SourceFolioId}`
                        } else if (row.TransferDestinationFolioID) {
                            const val = text("DestinationFolio")
                            return `${val}: ${row.TransferDestinationFolioID}`
                        } else {
                            return ""
                        }
                    }
                },
                { name: "", title: text("Actions") }
            ],
            selectable: true,
            cacheId: 'TransactionGrid',
            customOptions: {
                group: {
                    grouping: [{ columnName: 'InvoiceID' }]
                }
            },
            summary: true,
            totalSummaryItems: [],
            groupSummaryItems: [{ columnName: 'AmountByTargetCurrencyID', type: 'sum', showInGroupFooter: false, alignByColumn: true }],
            selectableCallback: row=>{
                return row.InvoiceID === null
            },
            noSelectionCellContent: <Icon className="icon-money"/>
        }
    }, [transactions, users])
    /* eslint-enable react/display-name */
    /* eslint-enable react/prop-types */

    const postBooking = async ()=>{
        try {
            const result = await PostBooking({
                Id: reservation.Id,
                HotelId: HotelID
            })
            console.log(result)
        } catch (error) {
            error.status === 400?onWarning(error):onError(error)
        }
    }

    const cancelPostBooking = async ()=>{
        try {
            const spec = {
                HotelId: HotelID,
                ReservationIds: [reservation.Id]
            }
            await ValidateIsEnableCancelPostBooking(spec)
            const result = await CancelPostBooking(spec)
            console.log(result)
        } catch (error) {
            error.status === 400?onWarning(error):onError(error)
        }
    }

    const addFolio = async settings=>{
        console.log(settings)
        setShowAddFolio(false)
        // try {
        //     const newFolio = await CreateFolios({
        //         HotelId: HotelID,

        //     })
        // } catch (error) {
        //     error.status === 400?onWarning(error):onError(error)
        // }
    }

    const noselection = selected.length === 0
    const selectedIDs = transactions.filter((x, idx)=>selected.includes(idx)).map(x=>x.Id)

    return <div className="TransactionsGrid">
        <Panel header={text("Transactions")} menu={
            <Menu borderless attached>
                <Menu.Item><Button positive content={text("AddNewTransaction")}></Button></Menu.Item>
                <Menu.Item><Button negative disabled={noselection} content={text("DeleteSelected")}></Button></Menu.Item>
                <Menu.Item position="right">
                    <Button.Group icon>
                        <Popup position='top right' content={text("CancelPostBooking")} trigger={<Button icon onClick={cancelPostBooking}><Icon className="icon-businessman-16" /></Button>} />
                        <Popup position='top right' content={text("PostBooking")} trigger={<Button icon onClick={postBooking}><Icon className="icon-businessman-4" /></Button>} />
                        <Popup position='top right' content={text("SplitForApartmentOwner")} trigger={<Button icon><Icon className="icon-home-7" /></Button>} />
                        <Popup position='top right' content={text("AutoBalance")} trigger={<Button disabled={noselection} icon><Icon className="icon-weight-balance" /></Button>} />
                        <Popup position='top right' content={text("Proforma")} trigger={<Button disabled={noselection} icon onClick={()=>setShowProforma(true)}><Icon className="icon-dollar-coins-stack" /></Button>} />
                        <Popup position='top right' content={text("DiscountAdjustment")} trigger={<Button disabled={noselection} icon><Icon className="icon-price-tag" /></Button>} />
                        <Popup position='top right' content={text("Split")} trigger={<Button disabled={noselection} icon><Icon className="icon-cut" /></Button>} />
                        <Popup position='top right' content={text("Transfertoanyfolio")} trigger={<Button disabled={noselection} icon onClick={()=>setShowTransferToFolio(true)}><Icon className="icon-archive-1" /></Button>} />
                        <Popup position='top right' content={text("AddFolio")} trigger={<Button onClick={()=>setShowAddFolio(true)} icon><Icon className="icon-wallet2" /></Button>} />
                    </Button.Group>
                </Menu.Item>
            </Menu>
        }>
            <GridPanel options={options} data={transactions} onSelected={setSelected}></GridPanel>
        </Panel>
        <AddFolioPopup open={showAddFolio} onCancel={()=>setShowAddFolio(false)} onSave={addFolio} reservation={reservation}/>
        <TransferToFolioPopup open={showTransferToFolio} onCancel={()=>setShowTransferToFolio(false)} HotelID={HotelID} reservation={reservation}/>
        <ProformaPopup open={showProforma} onCancel={()=>setShowProforma(false)} currencyId={currencyId} hotel={hotel} folio={folio} transactionIds={selectedIDs}/>
    </div>
}
TransactionsGrid.propTypes = {
    ReservationID: PropTypes.number,
    transactions: PropTypes.array,
    HotelID: PropTypes.number,
    reservation: PropTypes.object,
    folio: PropTypes.object,
    currencyId: PropTypes.number
}
export default TransactionsGrid